/* eslint-disable react-hooks/rules-of-hooks */
import { EntryGuard, Step, useScope } from 'ia-react-core';
import React, { useMemo } from 'react';
import MfaConfirmationStep from './MfaConfirmationStep';
import Constants from '../../../../Constants';
import { MfaValidationPageState } from '../../../../interfaces/MfaValidationPageState';

const getMfaConfirmationStep = () => {
  const { getScopedState } = useScope();

  const entryGuards = useMemo<EntryGuard[]>(() => [
    ({ redirect }) => {
      const workflow = getScopedState((state: MfaValidationPageState) => state?.values?.mfa);
      const isConfirmed = (
        workflow.informations?.phone &&
        workflow.informations?.email &&
        (
          !workflow.informations.hasPhoneChanged || (
            workflow.informations.phone === workflow.phone.codeRequestedFor
          )
        ) && (
          !workflow.informations.hasEmailChanged || (
            workflow.informations.email === workflow.email.codeRequestedFor
          )
        )
      );

      if (!isConfirmed) {
        return redirect(Constants.MfaInformationsStepSegment);
      }

      return undefined;
    },
  ], [getScopedState]);

  return (
    <Step
      name="confirmation"
      path={Constants.MfaConfirmationStepSegment}
      entryGuards={entryGuards}
    >
      <MfaConfirmationStep />
    </Step>
  );
};

export default getMfaConfirmationStep;
